import { createSlice } from '@reduxjs/toolkit'
import {
  sheetsSliceConfig as sheetsSliceBaseConfig,
  sheetsSliceExtraReducers as sheetsSliceBaseExtraReducers,
  createTableSheets,
} from 'apps/formsCreationKit/store/reducers/entities/sheets'
import { clearDisplayEntryRefs } from 'apps/formsCreationKit/lib/utils'
import {
  addPdf,
  resetPdf,
  createElement,
  updateElement,
  deleteElement,
  replacePdf,
  createTable,
  moveTable,
  deleteTable,
  deleteTableColumn,
} from 'apps/studio/store/actions/sharedActions'

const addSheetIfNecessary = (state, action) => {
  const { sheet } = action.payload

  if (sheet) {
    const updatedState = [...state, sheet]
    return updatedState.sort((a, b) => a.page_number - b.page_number)
  }
}

export const deleteSheetIfNecessary = (state, action) => {
  const { sheet: sheetToDelete } = action.payload
  const { id } = sheetToDelete
  return state.filter(sheet => sheet.id !== id)
}

const sheetsSliceStudioExtraReducers = builder => {
  builder
    .addCase(createElement, addSheetIfNecessary)
    .addCase(createTable, createTableSheets)
    .addCase(moveTable, (state, action) => {
      const { tableSheet, keyFieldSheet, fromPage, toPage } = action.payload
      if (fromPage.id === toPage.id) return state
      const updateById = new Map(
        [tableSheet, keyFieldSheet].map(s => [s.id, s])
      )
      return state
        .map(s => updateById.get(s.id) ?? s)
        .sort((a, b) => a.page_number - b.page_number)
    })
    .addCase(updateElement, (state, action) => {
      const { sheet, sectionToDelete } = action.payload

      let updatedState = state

      if (sectionToDelete) {
        updatedState = updatedState.filter(
          sheet => sheet.section_id !== sectionToDelete
        )
      }

      return sheet ? [...updatedState, sheet] : updatedState
    })
    .addCase(deleteElement, deleteSheetIfNecessary)
    .addCase(deleteTable, (state, action) => {
      const { keyFieldSheet, tableSheet } = action.payload
      const idsToRemove = new Set([keyFieldSheet.id, tableSheet.id])
      return state.filter(sheet => !idsToRemove.has(sheet.id))
    })
    .addCase(deleteTableColumn, (state, action) => {
      const { deletedEntryGuid } = action.payload
      return deletedEntryGuid
        ? clearDisplayEntryRefs(state, deletedEntryGuid)
        : state
    })
    .addCase(addPdf, () => [])
    .addCase(resetPdf, () => [])
    .addCase(replacePdf, (state, action) => {
      const { removedSectionIds } = action.payload
      return state.filter(sheet => !removedSectionIds.includes(sheet.section_id))
    })
}

export const sheetsSliceStudioConfig = {
  ...sheetsSliceBaseConfig,
  extraReducers: builder => {
    sheetsSliceBaseExtraReducers(builder)
    sheetsSliceStudioExtraReducers(builder)
  },
}

export const sheetsSlice = createSlice(sheetsSliceStudioConfig)
export const { actions: sheetsActions, reducer: sheetsReducer } = sheetsSlice
